
import React from 'react'
import { useQuery } from '@apollo/client';
import {useParams} from "react-router-dom";
import {getDateIntVideo} from '../../../../graphql-client/Queries'
import moment from 'moment';
import ButtonLikeVideo  from './buttonLikeVideo/ButtonLikeVideo';
import { FacebookShareButton, FacebookIcon, RedditIcon, RedditShareButton, WhatsappShareButton, WhatsappIcon } from 'react-share';
import { useAuthContext } from '../../../../context/AuthContext';
import { ConvertToCloudFrontUrl } from '../../../../utils/ConvertToCloudFrontUrl';
import { Helmet } from 'react-helmet-async';
export default function CardIntVideoPlaying() {
    let {id} = useParams();
    const {isAuthenticated} = useAuthContext()
    // Lấy URL hiện tại của trang
    const currentPageUrl = window.location.href;

    const {loading, error, data} = useQuery(getDateIntVideo,{
        variables: {id},
    });
    if(loading) return <p>loading...</p>;
    if (error) return <p>Error! {error.message}</p>;
    // Lấy thumbnail từ video hoặc dùng default image
    const thumbnailUrl = data.video.thumbnail 
        ? ConvertToCloudFrontUrl(data.video.thumbnail)
        : `https://linklearn.vn/FullLogo.jpg `; // Đường dẫn tới ảnh mặc định
    
    const shareTitle = `${data.video.title} - LinkLearn.vn`;
    const shareDescription = data.video.tags || 'Xem video học tập chất lượng cao trên LinkLearn.vn';
    
    return (
        <>
            {/* Dynamic Meta Tags cho sharing */}
            <Helmet>
                <title>{shareTitle}</title>
                <meta name="description" content={shareDescription} />
                
                {/* Open Graph cho Facebook, WhatsApp */}
                {/* <meta property="og:type" content="video.other" /> */}
                <meta property="og:title" content={shareTitle} />
                <meta property="og:description" content={shareDescription} />
                <meta property="og:image" content={thumbnailUrl} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={currentPageUrl} />
                <meta property="og:site_name" content="LinkLearn.vn" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={shareTitle} />
                <meta name="twitter:description" content={shareDescription} />
                <meta name="twitter:image" content={thumbnailUrl} />
                
                {/* Video specific meta */}
                {data.video.url && (
                    <>
                        <meta property="og:video" content={ConvertToCloudFrontUrl(data.video.url)} />
                        <meta property="og:video:type" content="video/mp4" />
                    </>
                )}
            </Helmet>
            
            <div className="p-2">
                <div className='d-flex flex-column'>
                    <h4 className='ps-2'>
                        {data.video.title}
                    </h4>
                    {data.video.tags && <p className='p-2 mb-0'>{data.video.tags}</p>}
                </div>
                <div className="intVideo d-flex justify-content-between">

                    <div className="statisticalVideo d-flex flex-row ">
                        <div className=' d-flex  p-2 pe-0'>
                            <div className="d-flex pe-1">
                                <p>
                                    {data.video.countView}
                                </p>
                                &nbsp;
                                <p>
                                    views
                                </p>
                            </div>
                            <div className='pe-1'>
                                •
                            </div>
                        </div>
                        <div className="d-flex flex-row p-2 ps-0">
                            <p>
                                {moment(data.video.createdAt).fromNow() }
                            </p>
                        </div>
                    </div>
                    <div className="iconVideoPlaying d-flex flex-md-row flex-column">
                        <div className="iconLikeVideo  d-flex mb-2 mx-auto me-1">
                            {
                                !isAuthenticated
                                ?<div className="m-auto me-1 ms-1">
                                    <i className='fas fa-heart'></i>
                                </div>
                                :<ButtonLikeVideo 
                                    countLike={data.video.countLike}
                                >
                                </ButtonLikeVideo>
                                
                            }
                            
                            <div className="d-flex flex-column likeTextVideo d-inline-flex">
                                <p>
                                    {data.video.countLike}
                                </p>
                                Thanks
                            </div>
                        </div>
                        <div className="shareVideo  d-flex me-1 ">
                            <i className="fas fa-share" title='Chia sẻ' />
                            <FacebookShareButton 
                                url={currentPageUrl}
                                quote={shareTitle}
                                hashtag="#LinkLearnVN"
                            >
                                <FacebookIcon  size={30} round={true}/>
                            </FacebookShareButton>
                            <RedditShareButton 
                                url={currentPageUrl}
                                title={shareTitle}
                            >
                                <RedditIcon  size={30} round={true} />
                            </RedditShareButton>

                            <WhatsappShareButton 
                                className='me-1' 
                                url={currentPageUrl}
                                title={shareTitle}
                                separator=" - "
                            >
                                <WhatsappIcon  size={30} round={true}/>
                            </WhatsappShareButton>
                        </div>       
                    </div>  
                </div>
            </div>
        </>
    )
}


